import { type LauncherUrlProps } from '@/utils/url/launcher-url';
import { GameUrl } from '@/app/components/game/subcomponents/game-url/game-url';
import { GameTileImageMobile } from '@/app/components/game/subcomponents/explore-row/mobile/game-tile-image/game-tile-image';
import { GameDetailsSection } from '@/app/components/game/subcomponents/explore-row/mobile/game-details-section/game-details-section';

import './styles/@theme';
import { NotificationIcon } from '@/app/elements/notification-icon/notification-icon';
import { useShouldShowNotification } from '@/hooks/use-show-notification-icon';
import { useGlobalContext } from '@/store/contexts/global-context';

type ExploreGamesRowProps = {
    uid: string;
    name: string;
    description: string;
    launcherUrlProps: LauncherUrlProps;
    logoUrl: string;
    backgroundUrl: string;
    customBackgroundColor: string;
    isPopup: boolean;
    zoneTitle: string;
    gameIndex: number;
    hideGameInfo?: boolean;
    label?: string;
    feedsCode?: string;
    isNew?: boolean;
    isSiteWideJackpot?: boolean;
};

export const ExploreGamesRow = ({
    uid,
    name,
    description,
    launcherUrlProps,
    logoUrl,
    backgroundUrl,
    customBackgroundColor,
    zoneTitle,
    gameIndex,
    hideGameInfo = false,
    label,
    feedsCode,
    isSiteWideJackpot,
    isNew = false
}: ExploreGamesRowProps) => {
    const { isSiteWideJackpotEnabled } = useGlobalContext();
    const shouldShowNotificationIcon = useShouldShowNotification(isNew);
    const isSWJAvailable = Boolean(isSiteWideJackpot && isSiteWideJackpotEnabled);

    return (
        <div
            className="explore-layout"
            data-gameuid={uid}
            data-t-gameuid={uid}
            data-t-gamename={name}
            data-t-gameposition={gameIndex}
            data-t-zonename={zoneTitle}
            data-t-zonemodule="game_zone"
            data-t-zonelayout="game_list">
            <GameUrl launcherUrlProps={launcherUrlProps}>
                <div className="tile layout-explore">
                    <GameTileImageMobile
                        logoUrl={logoUrl}
                        backgroundUrl={backgroundUrl}
                        customBackgroundColor={customBackgroundColor}
                    />
                    {shouldShowNotificationIcon && <NotificationIcon />}
                </div>
                <GameDetailsSection
                    gameBetInfo={description}
                    gameName={name}
                    hasJackpotValue={hideGameInfo}
                    uid={uid}
                    label={label}
                    isSWJAvailable={isSWJAvailable}
                    feedsCode={feedsCode}
                />
            </GameUrl>
        </div>
    );
};
